module.exports = __webpack_public_path__ + "img/self-assessments.f4ce246a.png";